function VirtualPTVideo({goToScheduler}) {
    return (
        <div id="v-pt-slider-2" className="v-pt-slides">
            <div id="v-pt-s2-header">

            </div>

            <div id="v-pt-s2-body">
                <h2>Your First Visit is On Us!</h2>
                <p>Receive a free assessment to see if virtual physical therapy is right for you.</p>
            </div>

            <div id="v-pt-s2-phone">
                <img src="assets/images/virtualPT/first_visit.png" />
            </div>
        </div>
    );
}

export default VirtualPTVideo;